<template lang="pug">
v-menu(
    v-model='reportDateMenu'
    :close-on-content-click='false'
    :nudge-right='40'
    transition='scale-transition'
    :offset-y='offsetY'
    :min-width='minWidth'
)
    template(v-slot:activator='{ props: activatorProps }')
        ValidatedTextField(
            v-bind='activatorProps'
            label='Report Date'
            prepend-icon='mdi-calendar'
            :rules='dateRule'
            v-model='selectedDateValue'
            hint='Select a date YYYY-MM-DD'
            allow-special-characters
            readonly
        )
    v-date-picker(
        @update:modelValue='updateSelectedDateValue'
        :max='maxDate'
        :allowed-dates='isDateAllowed'
    )
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ValidatedTextField from '@/common/Validation/ValidatedTextField.vue';
import { formatDateToYYYYMMDD } from '@/util/dateHelpers';

export default defineComponent({
    name: 'BaseDatePicker',
    components: {
        ValidatedTextField,
    },
    emits: ['update:selectedDate'],
    props: {
        selectedDate: {
            type: String,
            required: true,
        },
        reportDates: {
            type: Array as () => string[],
            default: () => [],
        },
        dateRule: {
            type: Array,
            default: () => [],
        },
        offsetY: {
            type: Boolean,
            default: true,
        },
        minWidth: {
            type: String,
            default: 'auto',
        },
        dataCy: {
            type: String,
            default: '',
        },
        dataCyCalendar: {
            type: String,
            default: '',
        },
        dataCyCloseDatePicker: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            selectedDateValue: this.selectedDate, // Initialize with prop value
            reportDateMenu: false,
        };
    },
    computed: {
        maxDate() {
            return new Date().toISOString().substr(0, 10);
        },
    },
    watch: {
        selectedDate: {
            immediate: true,
            handler(newVal) {
                this.selectedDateValue = newVal;
            },
        },
    },
    methods: {
        isDateAllowed(date: Date) {
            const dateString = date.toISOString().substr(0, 10);
            return this.reportDates.includes(dateString);
        },
        updateSelectedDateValue(date: string) {
            const formattedDate = formatDateToYYYYMMDD(date);
            this.selectedDateValue = formattedDate;

            this.closeDatePicker();
        },
        closeDatePicker() {
            this.reportDateMenu = false;
            this.$emit('update:selectedDate', this.selectedDateValue);
        },
    },
});
</script>
